import {FETCH_ADMIN_TEAMS_BEGIN, FETCH_ADMIN_TEAMS_SUCCESS, FETCH_ADMIN_TEAMS_FAILURE} from '../constants/action-types';
import {BASE_URL, API_URLS} from '../constants/config'
import {refreshTokens, logOut} from './usersActions'
import {checkIfTokenExpired, getTokensFromStore } from '../utilities/tokens'
import axios from 'axios';

export const fetchAdminTeamsBegin = () => ({
  type: FETCH_ADMIN_TEAMS_BEGIN
});

export const fetchAdminTeamsSuccess = teamsData => ({
  type: FETCH_ADMIN_TEAMS_SUCCESS,
  payload: { teamsData }
});

export const fetchAdminTeamsFailure = error => ({
  type: FETCH_ADMIN_TEAMS_FAILURE,
  payload: { error }
});

export function fetchAdminTeams() {
  let url = API_URLS.getAdminTeams
  return async dispatch => {
    const isTokenExpired = checkIfTokenExpired();
    if(isTokenExpired){
      await dispatch(refreshTokens())
    }
    const tokens = getTokensFromStore();
    dispatch(fetchAdminTeamsBegin());
    return axios.post(BASE_URL.url + url, {},
      {          
        headers: {
        "Authorization" : "Bearer " + tokens.access_token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
      }).then(res => {
      dispatch(fetchAdminTeamsSuccess(res));
      return res;
    })
        .catch((error) => {
          dispatch(fetchAdminTeamsFailure(error.response))
          if(error.response && error.response.status == 401) {
            dispatch(logOut())
          }
        });
  };
}
